import { MapTo, withComponentMappingContext } from '@adobe/aem-react-editable-components';

import { withTranslation } from '@yme/services/i18n';

import { AEM_FUNCTIONS } from '../../common';
import { withRoute } from '../RouteHelper/RouteHelper';

import ProductDetailsPage from './ProductDetailsPage';

export default MapTo([
  AEM_FUNCTIONS.productDetailsPage,
  AEM_FUNCTIONS.clothingProductDetailsPage,
  AEM_FUNCTIONS.accessoriesProductDetailsPage,
])(withTranslation(withComponentMappingContext(withRoute(ProductDetailsPage))));
